import { Box, Container, Heading, Text } from "@chakra-ui/react";

export default function Section({ id, eyebrow, title, children, ...rest }) {
  return (
    <Box as="section" id={id} py={{ base: 12, md: 20 }} {...rest}>
      <Container maxW="6xl">
        {eyebrow && (
          <Text color="brand.400" fontWeight="bold" letterSpacing="widest" fontSize="sm">
            {eyebrow}
          </Text>
        )}
        {title && (
          <Heading mt={2} mb={8} fontSize={{ base: "2xl", md: "4xl" }} color="text.heading">
            {title}
          </Heading>
        )}
        {children}
      </Container>
    </Box>
  );
}
